// @flow

import { combineReducers }  from 'redux';
import { localeReducer }    from 'react-localize-redux';
import user                 from './user';
import flash                from './flash';
import authMsg              from './authMsg';
import application          from './application';
import outboundAffiliates   from './outboundAffiliates';
import navigation           from './navigation';
import faq                  from './faq';

const rootReducer = combineReducers({
  user,
  flash,
  authMsg,
  application,
  outboundAffiliates,
  navigation,
  faq,
  locale: localeReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js